import { TimeFormatEnum } from 'common/components/entities/Calendar/constants'
import { RedirectionTypesEnum } from 'common/enums/ButtonActionEnum'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BookingCalendarInterface } from 'common/types/entities/BookingCalendarInterface'
import { BookingPaidCalendarInterface } from 'common/types/entities/booking-paid-calendar-interface'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { TFunction } from 'i18next'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export const createBookingCalendar = ({
  t,
  parentId,
  masterBlockId,
  type = EntityTypeEnum.BookingCalendar,
}: {
  t: TFunction
  parentId: string
  masterBlockId?: MasterBlockId
  type?: EntityTypeEnum.BookingCalendar | EntityTypeEnum.BookingPaidCalendar
}): BookingCalendarInterface | BookingPaidCalendarInterface => {
  const entity: BookingCalendarInterface | BookingPaidCalendarInterface = {
    ...generateBaseEntity(type, parentId, masterBlockId),
    type,
    padding: {
      paddingTop: 30,
      paddingRight: 30,
      paddingBottom: 30,
      paddingLeft: 30,
    },
    mobilePadding: {
      paddingTop: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingLeft: 5,
    },
    margin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },
    mobileMargin: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
    },

    eventId: undefined,
    availableSlotBackgroundColor: 'rgba(241, 244, 248, 1)',
    selectedSlotBackgroundColor: 'rgba(0, 160, 255, 1)',
    titlesColor: 'rgba(20, 45, 99, 1)',
    mobileTitlesColor: 'rgba(20, 45, 99, 1)',
    color: 'rgba(20, 45, 99, 0.6)',
    mobileColor: 'rgba(20, 45, 99, 0.6)',

    calendarStepHeadline: t(
      'entities.calendar.calendar_step_headline_default_text',
    ),
    calendarStepSubHeadline: t(
      'entities.calendar.calendar_step_sub_headline_default_text',
    ),
    formStepHeadline: t('entities.calendar.form_step_headline_default_text'),
    formStepSubHeadline: t(
      'entities.calendar.form_step_sub_headline_default_text',
    ),
    nextStepButtonText: t('entities.calendar.next_step_default_text'),
    formButtonText: t('entities.calendar.form_submit_default_text'),
    timeFormat: TimeFormatEnum.h24,

    fieldBorder: {
      color: 'rgba(158, 158, 158, 1)',
      style: BorderStyleEnum.solid,
      width: 1,
      radius: 5,
    },
    questions: [],

    thankYouStepButtonType: RedirectionTypesEnum.none,
    thankYouStepButtonText: t(
      'entity_settings.booking_calendar.thank_you_step_button_text',
    ),
    childIds: [],
  }

  return entity
}
